import { useTranslation } from 'react-i18next'

export default function GuideCard() {
  const { t } = useTranslation('home')

  return (
    <div className="bg-white rounded-xl shadow-lg p-8 border border-gray-200 hover:shadow-xl transition-all duration-300">
      <div className="flex items-center mb-6">
        <div className="w-12 h-12 bg-primary-50 rounded-lg flex items-center justify-center mr-4">
          <svg className="w-6 h-6 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.746 0 3.332.477 4.5 1.253v13C19.832 18.477 18.246 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
          </svg>
        </div>
        <h3 className="text-xl font-bold text-text-dark">{t('guide.title')}</h3>
      </div>
      <p className="text-gray-600 mb-4">
        {t('guide.description')}
      </p>
      <div className="space-y-3">
        {(t('guide.items', { returnObjects: true }) as string[]).map((item: string, index: number) => (
          <div key={index} className="flex items-center text-sm text-gray-600">
            <span className="w-2 h-2 bg-primary rounded-full mr-3"></span>
            {item}
          </div>
        ))}
      </div>
      <a
        href="https://docs.google.com/document/d/1GY3_gTNkjoPS3XBrCWl10c4uATxiOupCvAeMSVVsfJY/edit?tab=t.xin9hbg2jw6b"
        target="_blank"
        rel="noopener noreferrer"
        className="mt-8 text-primary hover:text-primary-600 font-medium inline-block"
      >
        {t('guide.button')}
      </a>
    </div>
  )
}